import { ViewStyle } from 'react-native';

import { PlayerTracks, SubtitlesFontSize } from 'store/player/reducer.types.ts';

export type BitmovinPlayerError = {
    code: number | string | null;
    message?: string | null | undefined;
    data?: Record<string, any>;
};

export type BitmovinPlayerSourceConfig = {
    startOffset?: number;
    startOffsetTimelineReference?: 'start' | 'end';
};

export type BitmovinPlayerSource =
    | {
          src: string;
          type: 'hls' | 'dash' | 'none';
          sourceConfig?: BitmovinPlayerSourceConfig;
          onGetContentToken?(): Promise<string>;
      }
    | undefined;

export type OnProgressEvent = {
    relativePosition: number | undefined;
    absolutePosition: number | undefined;
    timestamp: number;
};

export type PlayerProps = {
    source: BitmovinPlayerSource;
    style?: ViewStyle;
    muted?: boolean;
    volume?: number;
    statisticsUpdateInterval?: number;
    webSubtitleFontSize?: SubtitlesFontSize;
    mobileSubtitleFontSize?: number;
    onReady({
        duration,
    }: {
        duration: number | null | undefined;
    }): Promise<void>;
    onSeeked(): void;
    onProgress(e: OnProgressEvent): void;
    onError(error: BitmovinPlayerError): void;
    onPlayerSourceLoaded?(): void;
    onEnd?(): void;
    onPaused?(): void;
    onPlaying?(): void;
    onWaiting?(): void;
    // onStopped?: OtvPlayerProps['onStopped'];
    onTracksChanged?(tracks: PlayerTracks): void;
    onStatisticsUpdate?(statistics: StatisticsUpdateEvent): void;
};

export type PlayerRef = {
    play(): void;
    pause(): void;
    seek(p: number): void;
    unload(): Promise<void>;
    timeShift(offset: number): void;
    getTimeShift(): Promise<number | undefined>;
    getMaxTimeShift(): Promise<number | undefined>;
    getDuration(): Promise<number | null | undefined>;
    getIsLive(): Promise<boolean | undefined>;
    selectAudioTrack(trackId: string | undefined): Promise<void>;
    selectTextTrack(trackId: string | undefined): Promise<void>;
};

export enum AudioTrackEncodeType {
    AAC = 0,
    AC3 = 1,
    DTS = 2,
    MPEG = 3,
    UNKNOWN = 1000,
}

export type StatisticsUpdateEvent = {
    url: string | undefined;
    availableBitrates: number[] | undefined;
    streamBitrate: number | undefined;
    selectedBitrate: number | undefined;
    downloadBitrate: number | undefined;
    downloadBitrateAverage: number | undefined;
    bufferedDuration: number | undefined;
    droppedVideoFrames: number | undefined;
    totalVideoFrames: number | undefined;
    bytesDownloaded: number | undefined;
};
